// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAcQoF06p044oLk1gh1nhnU3cPvJm3V8O4",
  authDomain: "cargotracker-c904c.firebaseapp.com",
  projectId: "cargotracker-c904c",
  storageBucket: "cargotracker-c904c.firebasestorage.app",
  messagingSenderId: "35898933018",
  appId: "1:35898933018:web:1caa371808824e05b5f6a3",
  measurementId: "G-868PRCGJ8N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider, analytics, db };
export default app;